import { useEffect, useState, useCallback } from 'react';
import { getKVPair, upsertKVPair } from '../../../api';
import { KVPairs } from '../../../types';
import { toast } from 'react-toastify';

interface FormDefaults {
  [key: string]: any;
}

export const useFormDefaults = (rememberKey: string, isEditMode: boolean) => {
  const [defaults, setDefaults] = useState<FormDefaults>({});
  const [isLoadingDefaults, setIsLoadingDefaults] = useState(false);

  // Load defaults only when creating new (not editing)
  useEffect(() => {
    if (!isEditMode && rememberKey) {
      setIsLoadingDefaults(true);
      getKVPair('formDefaults', rememberKey)
        .then(response => {
          if (response && response.value) {
            try {
              const parsedDefaults = JSON.parse(response.value);
              setDefaults(parsedDefaults);
            } catch (error) {
              console.error('Error parsing defaults:', error);
            }
          }
        })
        .catch(error => {
          console.error('Error fetching defaults:', error);
        })
        .finally(() => {
          setIsLoadingDefaults(false);
        });
    }
  }, [rememberKey, isEditMode]);

  const saveDefault = useCallback((fieldName: string, value: any,showToast?:boolean) => {
    const updatedDefaults = {
      ...defaults,
      [fieldName]: value,
    };

    const kvPair: KVPairs = {
      key: 'formDefaults',
      object: rememberKey,
      value: JSON.stringify(updatedDefaults),
    };

    return upsertKVPair(kvPair)
      .then(() => {
        setDefaults(updatedDefaults);
        if(showToast) toast.success(`${'Default saved for'.toTranslatedDisplay()} ${fieldName}`);
        return true;
      })
      .catch(error => {
        console.error('Error saving default:', error);
        toast.error('Error saving default value'.toTranslatedDisplay());
        return false;
      });
  }, [defaults, rememberKey]);

  const getDefault = useCallback((fieldName: string) => {
    return defaults[fieldName];
  }, [defaults]);

  return {
    defaults,
    isLoadingDefaults,
    saveDefault,
    getDefault,
  };
};